import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';
import Button from 'components/generalUI/Button';
import { MappedPurchase } from 'apollo/types';
import PurchaseCard from '../PurchaseCard';
import styles from './ClientPurchases.module.scss';

interface ClientPurchasesProps {
  changeablePurchases: MappedPurchase[];
  token: string;
}

const ClientPurchases: FC<ClientPurchasesProps> = (props: ClientPurchasesProps) => {
  const { t } = useTranslation();

  const { changeablePurchases, token } = props;
  const [selectedPurchase, setPurchase] = useState<MappedPurchase | undefined>();

  const setFirstPurchase = () => {
    if (changeablePurchases.length) {
      const [purchase] = changeablePurchases;
      setPurchase(purchase);
    }
  };

  useEffect(() => {
    setFirstPurchase();
  }, []);

  return (
    <>
      {!changeablePurchases.length ? (
        <Row justify="center">
          <Col xs={22} md={20} xl={16}>
            <h3>{t('checkout.purchaseChange.noPurchasesMessage')}</h3>
          </Col>
        </Row>
      ) : (
        <>
          <Row justify="center">
            <Col span={18}>
              <h3>{t('checkout.purchaseChange.selectPurchase')}</h3>
            </Col>
          </Row>
          {changeablePurchases.map((purchase) => (
            <Row className={styles.Row} justify="center" key={purchase.id}>
              <Col span={18}>
                <PurchaseCard
                  mappedPurchase={purchase}
                  setPurchase={setPurchase}
                  isSelected={selectedPurchase?.id === purchase.id}
                />
              </Col>
            </Row>
          ))}
          <Row justify="center">
            <Col xs={22} md={20} xl={16}>
              <Button
                className={styles.ChangeDateButton}
                disabled={!selectedPurchase}
                onClick={() =>
                  sessionStorage.setItem(
                    'selectedPurchase',
                    JSON.stringify(selectedPurchase || '')
                  )
                }
                href={`/date/${token}`}
              >
                {t('checkout.purchaseChange.changeDate')}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ClientPurchases;
